function initializeOverlay() {
	(function () {
		var triggerBttn = document.getElementById('trigger-overlay'),
			overlay = document.querySelector('div.overlay')
		if (triggerBttn && overlay) {
			var closeBttn = overlay.querySelector('button.overlay-close');
			transEndEventNames = {
					'WebkitTransition': 'webkitTransitionEnd',
					'MozTransition': 'transitionend',
					'OTransition': 'oTransitionEnd',
					'msTransition': 'MSTransitionEnd',
					'transition': 'transitionend'
				},
				transEndEventName = transEndEventNames[Modernizr.prefixed('transition')],
				support = {
					transitions: Modernizr.csstransitions
				};
			s = Snap(overlay.querySelector('svg')),
				path = s.select('path'),
				steps = overlay.getAttribute('data-steps').split(';'),
				stepsTotal = steps.length;
	
			function toggleOverlay() {
				if (classie.has(overlay, 'open')) {
					var pos = stepsTotal - 1;
					classie.remove(overlay, 'open');
					classie.add(overlay, 'close');
	
					var onEndTransitionFn = function (ev) {
							classie.remove(overlay, 'close');
						},
						nextStep = function (pos) {
							pos--;
							if (pos < 0) return;
							path.animate({
								'path': steps[pos]
							}, 60, mina.linear, function () {
								if (pos === 0) {
									onEndTransitionFn();
								}
								nextStep(pos);
							});
						};
	
					nextStep(pos);
				} else if (!classie.has(overlay, 'close')) {
					var pos = 0;
					classie.add(overlay, 'open');
	
					var nextStep = function (pos) {
						pos++;
						if (pos > stepsTotal - 1) return;
						path.animate({
							'path': steps[pos]
						}, 60, mina.linear, function () {
							nextStep(pos);
						});
					};
	
					nextStep(pos);
				}
			}
	
			// class helper functions from bonzo https://github.com/ded/bonzo
	
			function classReg(className) {
				return new RegExp("(^|\\s+)" + className + "(\\s+|$)");
			}
	
			// classList support for class management
			// altho to be fair, the api sucks because it won't accept multiple classes at once
			var hasClass, addClass, removeClass;
	
			if ('classList' in document.documentElement) {
				hasClass = function (elem, c) {
					return elem.classList.contains(c);
				};
				addClass = function (elem, c) {
					elem.classList.add(c);
				};
				removeClass = function (elem, c) {
					elem.classList.remove(c);
				};
			} else {
				hasClass = function (elem, c) {
					return classReg(c).test(elem.className);
				};
				addClass = function (elem, c) {
					if (!hasClass(elem, c)) {
						elem.className = elem.className + ' ' + c;
					}
				};
				removeClass = function (elem, c) {
					elem.className = elem.className.replace(classReg(c), ' ');
				};
			}
	
			function toggleClass(elem, c) {
				var fn = hasClass(elem, c) ? removeClass : addClass;
				fn(elem, c);
			}
	
			var classie = {
				// full names
				hasClass: hasClass,
				addClass: addClass,
				removeClass: removeClass,
				toggleClass: toggleClass,
				// short names
				has: hasClass,
				add: addClass,
				remove: removeClass,
				toggle: toggleClass
			};
	
			// transport
			if (typeof define === 'function' && define.amd) {
				// AMD
				define(classie);
			} else {
				// browser global
				window.classie = classie;
			}
	
			triggerBttn.addEventListener('click', toggleOverlay);
			closeBttn.addEventListener('click', toggleOverlay);
		}
	})();
}